function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.5,
  fill: "#FCB154",
  stroke: "#E6A462"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.879 12.162c-3.874 5.087-8.032 2.22-9.76-.005-.05-.065-.003-.157.079-.157h9.604c.082 0 .127.097.077.162zM6.81 5.585a.2.2 0 01.38 0l.439 1.35a.2.2 0 00.19.138h1.419a.2.2 0 01.117.362l-1.148.834a.2.2 0 00-.072.223l.438 1.35a.2.2 0 01-.308.223l-1.147-.834a.2.2 0 00-.236 0l-1.147.834a.2.2 0 01-.308-.223l.438-1.35a.2.2 0 00-.072-.223l-1.148-.834a.2.2 0 01.117-.362h1.42a.2.2 0 00.19-.138l.438-1.35zM12.81 5.585a.2.2 0 01.38 0l.439 1.35a.2.2 0 00.19.138h1.419a.2.2 0 01.117.362l-1.148.834a.2.2 0 00-.072.223l.438 1.35a.2.2 0 01-.308.223l-1.147-.834a.2.2 0 00-.236 0l-1.147.834a.2.2 0 01-.308-.223l.438-1.35a.2.2 0 00-.072-.223l-1.148-.834a.2.2 0 01.117-.362h1.42a.2.2 0 00.19-.138l.438-1.35z",
  fill: "#000"
});
function SvgEmojiExcellent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgEmojiExcellent;